import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import InputField from '../reusable-component/InputField';
import CustomRuleSelector from '../reusable-component/CustomRuleSelector';
import PredefinedRuleSelector from '../reusable-component/PredefinedRuleSelector';
import { fetchRuleSelectorMetricList } from "../api's/DataProcessorApi";

function RulesSelectorPage2({
  disableForm,
  fetchedHeader,
  fetchGraphs,
  formField,
  setFormField,
  handleInputChange,
  handleSelectAllClick,
  handleAdd,
  handleColumnAddPredefined,
  uniqueId,
  selectedColumnName,
  handleUniqueId,
  handleDelete,
  handleChange,
  handleColumnDeletePredefined,
  handleColumnChangePredefined,
  configData,
  loading,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [metricList, setMetricList] = useState([]);

  const getRuleSelectorMetricList = async () => {
    try {
      const response = await fetchRuleSelectorMetricList();
      if (response.status === 200) {
        setMetricList(response.data);
      }
    } catch (error) {
      enqueueSnackbar('Error while fetching Metric List!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  useEffect(() => {
    getRuleSelectorMetricList();
  }, []);

  return (
    <>
      <Row>
        <InputField
          name="alias"
          label="Alias"
          value={formField.alias}
          onChange={handleInputChange}
          size="small"
          disabled
          required
          style={{ width: '30%' }}
        />
      </Row>
      <Row>
        <InputField
          name="innerPath"
          label="File Path"
          value={formField.innerPath}
          onChange={handleInputChange}
          size="small"
          disabled={disableForm}
          // required
          style={{ width: '80%' }}
        />

        <Button
          style={{
            width: '100px',
            height: '40px',
            margin: '10px 0 0 10px',
          }}
          variant="outlined"
          onClick={fetchGraphs}
          disabled={disableForm || formField?.innerPath?.length <= 0}
          className="outlined-button-color"
        >
          Fetch
        </Button>
      </Row>

      <br />
      <hr />

      {loading ? (
        <LinearProgress />
      ) : (
        formField.rule_list.length > 0 &&
        formField.rule_list[0]?.statement &&
        formField.innerPath !== '' && (
          <>
            <TableContainer sx={{ maxHeight: 450 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        color="primary"
                        disabled={disableForm}
                        checked={formField.rule_list.length > 0 && formField.rule_list.every((item) => item.checked)}
                        onChange={(event) => {
                          const isChecked = event.target.checked;
                          setFormField({
                            ...formField,
                            rule_list: formField.rule_list.map((item) => ({
                              ...item,
                              checked: isChecked,
                            })),
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <b>Metric</b>
                    </TableCell>
                    <TableCell>
                      <b>Statement</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formField.rule_list.map((row) => (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={row.checked}
                      tabIndex={-1}
                      key={row}
                      selected={row.checked}
                    >
                      <TableCell>
                        <Checkbox
                          checked={row.checked}
                          disabled={disableForm}
                          onChange={(event) => {
                            setFormField({
                              ...formField,
                              rule_list: formField.rule_list.map((item) =>
                                item.field_name === row.field_name ? { ...item, checked: event.target.checked } : item
                              ),
                            });
                          }}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </TableCell>
                      <TableCell>
                        <FormControl size="small" style={{ width: '150px' }}>
                          <InputLabel>Metric</InputLabel>
                          <Select
                            id="demo-simple-select-helper"
                            name="metric"
                            size="small"
                            label="Metric"
                            value={row.metric}
                            onChange={(e) => {
                              setFormField({
                                ...formField,
                                rule_list: formField.rule_list.map((item) =>
                                  item.field_name === row.field_name ? { ...item, metric: e.target.value } : item
                                ),
                              });
                            }}
                            // key={data.id}
                            disabled={disableForm}
                            sx={{ background: '#ffffff' }}
                          >
                            {metricList
                              ?.sort((a, b) => a.metric_type?.localeCompare(b.metric_type))
                              ?.map((item) => (
                                <MenuItem key={item.rm_id} value={item.metric_type}>
                                  {item.metric_type}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>{row.statement}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )
      )}
      <hr />

      <PredefinedRuleSelector
        uniqueId={uniqueId}
        columnName={fetchedHeader}
        selectedColumnName={selectedColumnName}
        handleUniqueId={handleUniqueId}
        metricList={metricList}
        handleAdd={handleColumnAddPredefined}
        handleChange={handleColumnChangePredefined}
        handleDelete={handleColumnDeletePredefined}
        configDataNew={formField.configDataNew}
        disableForm={disableForm}
      />
      <br />
      <hr />
      <CustomRuleSelector
        uniqueId={uniqueId}
        columnName={fetchedHeader}
        selectedColumnName={selectedColumnName}
        handleUniqueId={handleUniqueId}
        handleAdd={handleAdd}
        handleDelete={handleDelete}
        configData={formField.configData}
        handleChange={handleChange}
        disableForm={disableForm}
        predefinedRules
      />
    </>
  );
}

export default RulesSelectorPage2;
